/**
 * Locale preference persistence (TMMAPP-0001) — the language only, beside the theme mode
 * (`tmm_theme_mode`). Never a token, never bootstrap data. Storage access is try/catch-guarded:
 * private mode reads as "no preference" and writes are dropped.
 */
import { LOCALE_STORAGE_KEY, normalizeLocale, type SupportedLocale } from './constants';

export function readStoredLocale(): SupportedLocale | null {
  try {
    return normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function writeStoredLocale(locale: SupportedLocale): void {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    /* localStorage unavailable — preference not persisted */
  }
}
